function getParam(paramName: string, url: string = window.location.href) {
  const name = paramName.replace(/[[]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function camelizeStr(str: string): string {
  return str.replace(/[_.-](\w|$)/g, (_, x) => x.toUpperCase());
}

function snakifyStr(str: string): string {
  return str.replace(/(?:^|\.?)([A-Z])/g, (_, x) => `_${x.toLowerCase()}`);
}

type ConvertFunc = (k: string) => string;
export type AnyJson = boolean | number | string | null | undefined | JsonArray | JsonMap;
interface JsonMap {
  [key: string]: AnyJson;
}
type JsonArray = Array<AnyJson>;

function convertCase(convertFunc: ConvertFunc) {
  function converter(thing: AnyJson): AnyJson {
    if (Array.isArray(thing)) {
      return thing.map((i) => converter(i));
    }
    if (thing && typeof thing === 'object') {
      const newObj: JsonMap = {};
      Object.keys(thing).forEach((k: string) => {
        newObj[convertFunc(k)] = converter(thing[k]);
      });
      return newObj;
    }
    return thing;
  }
  return converter;
}

function delay(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function setCookie(name: string, value: string | number, expires: Date, path?: string, domain?: string, secure?: string) {
  let cookieText = `${encodeURIComponent(name)}=`;

  if (typeof value === 'string') {
    cookieText += encodeURIComponent(value);
  } else {
    cookieText += value;
  }

  if (expires instanceof Date) {
    cookieText += `; expires=${expires.toUTCString()}`;
  }

  if (path) {
    cookieText += `; path=${path}`;
  }

  if (domain) {
    cookieText += `; domain=${domain}`;
  }

  if (secure) {
    cookieText += '; secure';
  }

  document.cookie = cookieText;
}

function setExpireDate(day = 7) {
  return new Date(Date.now() + 3600000 * 24 * day);
}

function getCookie(name: string) {
  const { cookie } = document;
  const cookieName = `${encodeURIComponent(name)}=`;
  const cookieStart = cookie.indexOf(cookieName);
  let cookieValue = null;

  if (cookieStart > -1) {
    let cookieEnd = cookie.indexOf(';', cookieStart);
    if (cookieEnd === -1) {
      cookieEnd = cookie.length;
    }
    cookieValue = decodeURIComponent(
      cookie.substring(cookieStart + cookieName.length, cookieEnd),
    );
  }

  return cookieValue;
}

const getTime = (time: number) => {
  return new Date(time * 1000).toLocaleString()
}


export default {
  getParam,
  camelizeStr,
  snakifyStr,
  delay,
  camelizeKeys: convertCase(camelizeStr),
  snakifyKeys: convertCase(snakifyStr),
  setCookie,
  setExpireDate,
  getCookie,
  getTime,
};
